<template>
  <div ref="wrapperRef" class="mobile-floating-bar">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useResizeObserver } from '@vueuse/core';
import { onBeforeUnmount, ref } from 'vue';

defineSlots<{
  default: () => void;
}>();

// Try to add bottom padding by the content height
const wrapperRef = ref<HTMLDivElement>();

useResizeObserver(wrapperRef, () => {
  console.log(wrapperRef.value?.clientHeight);

  const app = document.getElementById('app');

  if (app) {
    app.style.paddingBottom = `${wrapperRef.value?.clientHeight}px`;
  }
});

onBeforeUnmount(() => {
  const app = document.getElementById('app');

  if (app) {
    app.style.paddingBottom = '0';
  }
});
</script>

<style scoped lang="scss">
.mobile-floating-bar {
  @include md-and-up {
    display: contents;
  }

  @include sm-and-down {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: $z-index-5;

    padding: 12px 24px;

    background-color: $main-bg-color;
  }

  @include extra-xs {
    padding: 12px 16px;
  }
}
</style>
